import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../hooks/usedTypedSelector";
import { getBooks } from "../../../features/middleware/bookMiddleware";

const DigitalDownload = () => {
  // card hover effect object
  const cardHover = {
    boxShadow:
      "rgba(0, 0, 0, 0.05) 4px 4px 26px 5px, rgba(0, 0, 0, 0.02) 6px 8px 26px 0px",
    transform: "translate(0px, -10px)",
    cursor: "pointer",
  };
  // redux dispatch func to fetch data from middleware asyncthunk
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBooks());
  }, [dispatch]);
  const { loading, dataBook } = useAppSelector((state) => state.bookSlice);
  console.log(dataBook);
  return (
    <Container
      maxWidth="lg"
      sx={{
        padding: { xs: "30px 0 21px", sm: "30px 0 21px", md: "30px 0 100px" },
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Grid container>
          {loading && (
            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid container spacing={4}>
          {dataBook &&
            dataBook?.slice(0, 4).map((item, i) => (
              <Grid item xs={12} sm={6} md={6} key={i}>
                <Card
                  sx={{
                    maxWidth: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.05) 0px 1px 18px 0px, rgba(0, 0, 0, 0.07) 0px 3px 5px -1px",
                    transition: "all 0.4s ease 0s",
                    borderRadius: 0,
                    "&:hover": cardHover,
                  }}
                >
                  <CardMedia
                    component="img"
                    alt="download image"
                    height="auto"
                    image={item.img}
                    sx={{ width: "45%" }}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description.slice(0, 180)}
                    </Typography>
                    <CardActions>
                      <Box
                        sx={{
                          textAlign: { xs: "center", sm: "center", md: "left" },
                          mb: 3.7,
                        }}
                      >
                        <Link to="/download" style={{ textDecoration: "none" }}>
                          <div className="button_slide_cmn slide_down_cmn">
                            Download{" "}
                          </div>
                        </Link>
                      </Box>
                    </CardActions>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default DigitalDownload;
